import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-517290c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapping" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "item-detail"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p data-v-517290c6>【2020年代】</p><p data-v-517290c6>建設機械レンタル管理システムリニューアル</p><p data-v-517290c6>製薬会社向け購買システム構築,他社カタログ連携</p><p data-v-517290c6>【2010年代】</p><p data-v-517290c6>動画配信サイト電子決済機能作成</p><p data-v-517290c6>不動産会社向け物件紹介サイト会員機能等の作成</p><p data-v-517290c6>米国SNS日本版FPアプリ作成</p><p data-v-517290c6>電力会社/震災に伴うシステム改修</p><p data-v-517290c6>【2000年代】</p><p data-v-517290c6>商社/会計システムリニューアル</p><p data-v-517290c6>旅行会社/航空会社合併に伴うシステム改修</p><p data-v-517290c6>携帯電話会社/窓口システムOSバージョンアップ対応（Window3.1から2000）</p><p data-v-517290c6>お弁当販売会社/季節商品注文ページ作成/伝票出力機能作成</p><p data-v-517290c6>【1990年代】</p><p data-v-517290c6>POSレジ2000年対応</p><p data-v-517290c6>テーマパーク団体予約システム構築/チケット発行機能作成</p><p data-v-517290c6>外国為替システム/被仕向送金機能改修</p><p class=\"mt-10\" data-v-517290c6>※改組前（当社設立前）のものを含みます。</p><p data-v-517290c6>※規模が大きい案件では部分的に対応しております。</p>", 19)
const _hoisted_25 = [
  _hoisted_6
]
const _hoisted_26 = {
  key: 1,
  class: "item-detail-en"
}
const _hoisted_27 = ["textContent"]

import { ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SupportExamples',
  props: ['translate'],
  setup(__props) {

  const props = __props 

  const examplesEn = ref(`準備中`)
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.translate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "対応事例"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Support Examples"))
    ]),
    (props.translate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_25))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("p", {
            textContent: _toDisplayString(examplesEn.value)
          }, null, 8, _hoisted_27)
        ]))
  ]))
}
}

})